module.exports = __webpack_public_path__ + "img/info.30a5f75d.svg";